module.exports = __webpack_public_path__ + "static/media/Davis_Mark.1cb4ff5d.png";